import '../App.css';
import {useState,useEffect} from 'react';  
import image from '../Images/HackerEarth_logo.png';  
import Loader from '../Loader';
import Header from '../Header';
import { PageType } from '../Constants';
function Hackerearth(){
         const [data,setData]=useState(null);
         const [img,Setimg]=useState(image);  
         useEffect(()=>{
            fetch('https://kontests.net/api/v1/hacker_earth').then((data)=>data.json()).then((response)=>{  
                   setData(response);  
            });  
         },[]);
         useEffect(()=>{
          window.scrollTo(0,0);
      },[]);
    return (
        <>
        {data==null ? <Loader/> : null}
        {data != null && <>
        <Header Pagetype={PageType.CONTEST_PAGE} Title={"HackerEarth Contests"} />
        {data.map((Data)=>
        <div className="card"> 
             <div className="img-div">
                  <img className="img" src={img} title="Hackerearth"></img>  
             </div>
             <div className="divbody">   
                  <p className="card-title">{Data.name}</p> 
                  <a href={Data.url} target="_blank"><button className="btn">Enter</button></a>  
             </div>
        </div> 
        )}
        </>
      }
     </>  
    );
}
export default Hackerearth;     